<div>

  <!-- =========================
       CTA BAND
  ========================== -->
  <section class="bg-danger py-5">
    <div class="container-fluid px-3 px-md-4 px-lg-5">
      <div class="row align-items-center gy-3">
        <div class="col-12 col-lg-8">
          <h2 class="fw-bold text-white mb-1">Ready to see everything?</h2>
          <p class="text-white text-opacity-75 mb-0">Log in to access your live property dashboard.</p>
        </div>
        <div class="col-12 col-lg-4 text-lg-end">
          <router-link
            to="/login"
            class="btn btn-light bcx-cta-btn text-danger text-decoration-none d-inline-flex align-items-center gap-2"
          >
            Access Dashboard
            <i class="bi bi-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </section>

  <!-- =========================
       FOOTER
  ========================== -->
  <footer class="bg-black text-white-50 pt-5 pb-4">
    <div class="container-fluid px-3 px-md-4 px-lg-5">
      <div class="row gy-5">

        <div class="col-12 col-lg-5">
          <a href="/" class="navbar-brand brand-logo d-inline-block mb-3" aria-label="BCX Home"></a>
          <p class="text-white-50 mb-0" style="max-width: 26rem;">
            Smart, integrated utilities monitoring for properties &mdash; bringing energy,
            security, and connectivity data together in one live dashboard.
          </p>
        </div>

        <div class="col-6 col-lg-2">
          <h6 class="text-white text-uppercase text-xs fw-bold mb-3" style="letter-spacing: 0.06em;">Quick Links</h6>
          <ul class="list-unstyled d-flex flex-column gap-3 mb-0">
            <li>
              <router-link to="/" class="bcx-footer-link link-underline link-underline-opacity-0 link-underline-opacity-100-hover">
                <i class="bi bi-house-door-fill"></i> Home
              </router-link>
            </li>
            <li>
              <router-link to="/login" class="bcx-footer-link link-underline link-underline-opacity-0 link-underline-opacity-100-hover">
                <i class="bi bi-box-arrow-in-right"></i> Login
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col-6 col-lg-2">
          <h6 class="text-white text-uppercase text-xs fw-bold mb-3" style="letter-spacing: 0.06em;">Account</h6>
          <ul class="list-unstyled d-flex flex-column gap-3 mb-0">
            <li>
              <router-link to="/reset_password" class="bcx-footer-link link-underline link-underline-opacity-0 link-underline-opacity-100-hover">
                <i class="bi bi-key-fill"></i> Reset password
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col-12 col-lg-3">
          <h6 class="text-white text-uppercase text-xs fw-bold mb-3" style="letter-spacing: 0.06em;">Platform</h6>
          <div class="d-inline-flex align-items-center gap-2 bcx-footer-status">
            <span class="bcx-live-dot"></span>
            Monitoring your properties, 24/7
          </div>
        </div>

      </div>

      <hr class="border-secondary opacity-25 my-4">

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 text-center text-sm-start">
        <small class="text-white-50">&copy; {{ rights.year }} {{ rights.company_name }}. All Rights Reserved.</small>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-2 text-xs"
          @click="scroll_to_top"
        >
          Back to top
          <i class="bi bi-arrow-up"></i>
        </button>
      </div>
    </div>
  </footer>

</div>
